export default __webpack_public_path__ + "static/media/interrogacion.6df54a07.svg";